import { render, staticRenderFns } from "./OptionsCategoriesForm.vue?vue&type=template&id=02937c16"
import script from "./OptionsCategoriesForm.vue?vue&type=script&lang=js"
export * from "./OptionsCategoriesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports